function animationGsapLinksFooter() {
  const selectAll = e => document.querySelectorAll(e);
  const panels = selectAll(".footer");

  if (panels.length === 0) {
      return;
  }

  gsap.registerPlugin(ScrollTrigger);
  // Animación para íconos sociales
  gsap.from(".gsap-footer-item", {
      opacity: 0,
      y: 10,
      duration: 1,
      stagger: 0.1,
      ease: "power5.out",
      scrollTrigger: {
          trigger: ".footer",
          start: "top 80%",
          end: "top 20%",
          once: true // Ejecutar solo una vez
      }
  });
}


animationGsapLinksFooter();

